import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import request from '@/utils/request'
import lazy from '@/directives/lazy'
import { isPrerenderEnv, notifyPrerenderReady } from '@/utils/prerender'

Vue.prototype.$request = request

Vue.directive('lazy', lazy)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    this.$router.onReady(() => {
      notifyPrerenderReady()
    })
  }
}).$mount('#app')

router.afterEach(() => {
  if (isPrerenderEnv()) {
    notifyPrerenderReady()
  }
})
